const blockCocaine = [
  //!========================================================================================
  /*                                                                                      *
   *                                   STARTBLOCKCOCAINE                                  *
   *                                                                                      */
  //!========================================================================================
  {
    id: "DA.1.1.64",
    shortname: "cocaine-block-subtopic",
    name: "Direction for Cocaine: Please answer the items in the grid below. Have there EVER been significant periods during which you...",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "subtopic",
    act: "COCAINE-BLOCK-SUBTOPIC",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
  },
  {
    id: "DA.1.1.65",
    shortname: "cocaine-block-6",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-6",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-7",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.65.1",
    extend: "true",
    shortname: "cocaine-block-7",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-7",
    depending: "COCAINE-BLOCK-6",
    exception: "This has happened",
    link: "COCAINE-BLOCK-8",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.65.2",
    extend: "true",
    shortname: "cocaine-block-8",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-8",
    depending: "COCAINE-BLOCK-6",
    exception: "This has happened",
    link: "COCAINE-BLOCK-9",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.65.3",
    extend: "true",
    shortname: "cocaine-block-9",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-9",
    depending: "COCAINE-BLOCK-6",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-1-CONTENT",
    subtopic_name:
      "This substance is often taken in larger amounts or over a longer period than was intended",
  },
  {
    id: "DA.1.1.66",
    shortname: "cocaine-block-10",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-10",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-11",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.66.1",
    extend: "true",
    shortname: "cocaine-block-11",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-11",
    depending: "COCAINE-BLOCK-10",
    exception: "This has happened",
    link: "COCAINE-BLOCK-12",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.66.2",
    extend: "true",
    shortname: "cocaine-block-12",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-12",
    depending: "COCAINE-BLOCK-10",
    exception: "This has happened",
    link: "COCAINE-BLOCK-13",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.66.3",
    extend: "true",
    shortname: "cocaine-block-13",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-13",
    depending: "COCAINE-BLOCK-10",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-2-CONTENT",
    subtopic_name:
      "There is a persistent desire or unsuccessful efforts to cut down or control this substance use",
  },
  {
    id: "DA.1.1.67",
    shortname: "cocaine-block-14",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-14",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-15",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.67.1",
    extend: "true",
    shortname: "cocaine-block-15",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-15",
    depending: "COCAINE-BLOCK-14",
    exception: "This has happened",
    link: "COCAINE-BLOCK-16",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.67.2",
    extend: "true",
    shortname: "cocaine-block-16",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-16",
    depending: "COCAINE-BLOCK-14",
    exception: "This has happened",
    link: "COCAINE-BLOCK-17",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.67.3",
    extend: "true",
    shortname: "cocaine-block-17",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-17",
    depending: "COCAINE-BLOCK-14",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-3-CONTENT",
    subtopic_name:
      "A great deal of time is spent in activities necessary to obtain this substance, use this substance, or recover from its effects",
  },
  {
    id: "DA.1.1.68",
    shortname: "cocaine-block-18",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-18",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-19",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.68.1",
    extend: "true",
    shortname: "cocaine-block-19",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-19",
    depending: "COCAINE-BLOCK-18",
    exception: "This has happened",
    link: "COCAINE-BLOCK-30",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.68.2",
    extend: "true",
    shortname: "cocaine-block-20",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-20",
    depending: "COCAINE-BLOCK-18",
    exception: "This has happened",
    link: "COCAINE-BLOCK-21",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.68.3",
    extend: "true",
    shortname: "cocaine-block-21",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-21",
    depending: "COCAINE-BLOCK-18",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-4-CONTENT",
    subtopic_name: "Craving, or a strong desire or urge to use this substance",
  },
  {
    id: "DA.1.1.69",
    shortname: "cocaine-block-22",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-22",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-23",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.69.1",
    extend: "true",
    shortname: "cocaine-block-23",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-23",
    depending: "COCAINE-BLOCK-22",
    exception: "This has happened",
    link: "COCAINE-BLOCK-24",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.69.2",
    extend: "true",
    shortname: "cocaine-block-24",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-24",
    depending: "COCAINE-BLOCK-22",
    exception: "This has happened",
    link: "COCAINE-BLOCK-25",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.69.3",
    extend: "true",
    shortname: "cocaine-block-25",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-25",
    depending: "COCAINE-BLOCK-22",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-CONTENT",
    subtopic_name:
      "Recurrent use of this substance resulting in a failure to fulfill major role obligations at work, school, or home",
  },
  {
    id: "DA.1.1.70",
    shortname: "cocaine-block-26",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-26",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-27",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.70.1",
    extend: "true",
    shortname: "cocaine-block-27",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-27",
    depending: "COCAINE-BLOCK-26",
    exception: "This has happened",
    link: "COCAINE-BLOCK-28",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.70.2",
    extend: "true",
    shortname: "cocaine-block-28",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-28",
    depending: "COCAINE-BLOCK-26",
    exception: "This has happened",
    link: "COCAINE-BLOCK-29",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.70.3",
    extend: "true",
    shortname: "cocaine-block-29",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-29",
    depending: "COCAINE-BLOCK-26",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-6-CONTENT",
    subtopic_name:
      "Continues use of this substance despite having persistent or recurrent social or interpersonal problems caused or exacerbated by the effects of this substance",
  },
  {
    id: "DA.1.1.71",
    shortname: "cocaine-block-30",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-30",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-31",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.71.1",
    extend: "true",
    shortname: "cocaine-block-31",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-31",
    depending: "COCAINE-BLOCK-30",
    exception: "This has happened",
    link: "COCAINE-BLOCK-32",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.71.2",
    extend: "true",
    shortname: "cocaine-block-32",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-32",
    depending: "COCAINE-BLOCK-30",
    exception: "This has happened",
    link: "COCAINE-BLOCK-33",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.71.3",
    extend: "true",
    shortname: "cocaine-block-33",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-33",
    depending: "COCAINE-BLOCK-30",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-7-CONTENT",
    subtopic_name:
      "Important social, occupational, or recreational activities are given up or reduced because of this substance use",
  },
  {
    id: "DA.1.1.72",
    shortname: "cocaine-block-34",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-34",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-35",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.72.1",
    extend: "true",
    shortname: "cocaine-block-35",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-35",
    depending: "COCAINE-BLOCK-34",
    exception: "This has happened",
    link: "COCAINE-BLOCK-36",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.72.2",
    extend: "true",
    shortname: "cocaine-block-36",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-36",
    depending: "COCAINE-BLOCK-34",
    exception: "This has happened",
    link: "COCAINE-BLOCK-37",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.72.3",
    extend: "true",
    shortname: "cocaine-block-37",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-37",
    depending: "COCAINE-BLOCK-34",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-8-CONTENT",
    subtopic_name:
      "Recurrent use of this substance in situations in which it is physically hazardous",
  },
  {
    id: "DA.1.1.73",
    shortname: "cocaine-block-38",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-38",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-39",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.73.1",
    extend: "true",
    shortname: "cocaine-block-39",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-39",
    depending: "COCAINE-BLOCK-38",
    exception: "This has happened",
    link: "COCAINE-BLOCK0",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.73.2",
    extend: "true",
    shortname: "cocaine-block-40",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-40",
    depending: "COCAINE-BLOCK-38",
    exception: "This has happened",
    link: "COCAINE-BLOCK-41",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.73.3",
    extend: "true",
    shortname: "cocaine-block-41",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-41",
    depending: "COCAINE-BLOCK-38",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-9-CONTENT",
    subtopic_name:
      "Use of this substance is continued despite knowledge of having a persistent or recurrent physical or psychological problem that is likely to have been caused or exacerbated by this substance",
  },
  {
    id: "DA.1.1.74",
    shortname: "cocaine-block-42",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-42",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-43",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.74.1",
    extend: "true",
    shortname: "cocaine-block-43",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-43",
    depending: "COCAINE-BLOCK-42",
    exception: "This has happened",
    link: "COCAINE-BLOCK-44",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.74.2",
    extend: "true",
    shortname: "cocaine-block-44",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-44",
    depending: "COCAINE-BLOCK-42",
    exception: "This has happened",
    link: "COCAINE-BLOCK-45",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.74.3",
    extend: "true",
    shortname: "cocaine-block-45",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-45",
    depending: "COCAINE-BLOCK-42",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-10-CONTENT",
    subtopic_name:
      "Tolerance, as defined by either of the following:-A need for markedly increased amounts of this substance to achieve intoxication or desired effect; - A markedly diminished effect with continued use of the same amount of this substance",
  },
  {
    id: "DA.1.1.75",
    shortname: "cocaine-block-46",
    name: "",
    prevalue: "",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["This has happened", "Never"],
    act: "COCAINE-BLOCK-46",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    link: "COCAINE-BLOCK-47",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.75.1",
    extend: "true",
    shortname: "cocaine-block-47",
    name: "",
    prevalue: "Age this began",
    value: "",
    disabled: "true",
    type: "text",
    act: "COCAINE-BLOCK-47",
    depending: "COCAINE-BLOCK-46",
    exception: "This has happened",
    link: "COCAINE-BLOCK-48",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.75.2",
    extend: "true",
    shortname: "cocaine-block-48",
    name: "",
    prevalue: "During the past 3 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-48",
    depending: "COCAINE-BLOCK-46",
    exception: "This has happened",
    link: "COCAINE-BLOCK-49",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.75.3",
    extend: "true",
    shortname: "cocaine-block-49",
    name: "",
    prevalue: "During the past 12 months",
    value: "",
    disabled: "true",
    type: "radio",
    radio_options: ["Yes", "No"],
    act: "COCAINE-BLOCK-49",
    depending: "COCAINE-BLOCK-46",
    exception: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-11-CONTENT",
    subtopic_name:
      "Withdrawal, as manifested by either of the following: - The characteristic withdrawal syndrome for this substance; - Other substance(s)is/are taken to relieve or avoid withdrawal symptoms",
  },
  {
    id: "DA.1.1.76",
    shortname: "cocaine-block-50",
    name: "Number of criteria met for:",
    prevalue: "Number of criteria met for (Cocaine):",
    value: "0",
    disabled: "true",
    type: "content",
    comment: "Consider no diagnosis for [substance}",
    act: "COCAINE-BLOCK-50",
    depending: "DA0",
    exception: "Cocaine",
    condition: "in",
    meaningfulcount: "This has happened",
    subtopic_container_act: "COCAINE-BLOCK-SUBTOPIC",
    suptopic_code: "COCAINE-BLOCK-12-CONTENT",
    subtopic_name: "Content Criteria",
  },
  //!========================================================================================
  /*                                                                                      *
   *                                    ENDBLOCKCOCAINE                                   *
   *                                                                                      */
  //!========================================================================================
];

export default blockCocaine;
